import { FC, useMemo } from "react";

import { NO_VALUE_DISPLAY } from "@ryde/shared";

import { FramerTooltip } from "../../common";
import { useDecorateWithMark } from "../../utils";
import { IRenderColumnTemplate } from "./_core";

export const TextCellTemplate: FC<IRenderColumnTemplate> = ({
  id,
  value,
  valueTranslated,
  name,
  gridFieldTypeId,
  e2eData,
}) => {
  const { decorateValue } = useDecorateWithMark();
  const isHighlightElement = useMemo(() => {
    return (
      Array.isArray(value) &&
      value.some(
        item =>
          typeof item === "object" &&
          item !== null &&
          "type" in item &&
          typeof item.type === "function",
      )
    );
  }, [value]);

  const valueComputed = useMemo(() => {
    if (isHighlightElement) {
      return value;
    }

    const baseValue = valueTranslated ? String(valueTranslated) : String(value);
    return decorateValue(baseValue);
  }, [isHighlightElement, value, valueTranslated, decorateValue]);

  const tooltipContent = useMemo(() => {
    return valueTranslated ? String(valueTranslated) : String(value);
  }, [valueTranslated, value]);

  return (
    <div
      className="cell_simple"
      data-e2e-id={`${name}_fieldid_${gridFieldTypeId}`}
      data-e2e-value={value}
      data-e2e-template={"text-cell"}
      data-e2e-custom={e2eData}
      data-e2e-custom-field-id={id}
    >
      <FramerTooltip content={tooltipContent} rtlStrippedBottomLeftPlacement>
        <span>{valueComputed || NO_VALUE_DISPLAY}</span>
      </FramerTooltip>
    </div>
  );
};
